import React from 'react';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Modal, Button, Tabs} from 'antd';

import CloudAccountFilterContainer from '../../containers/cloud-account-filter-container';
import CloudAccountListContainer from '../../containers/cloud-account-list-container';
import ActiveJobsList from '../AdminDashboard/ActiveJobs/activeJobs';
import SyncList from '../SyncC2cWasabi/SyncList/SyncList';
import TransferHistory from './TransferHistory/transferHistory'
// import UsersList from './Users/users';
// import ServiceUsage from './Usage/usage';
// import TransferReport from './RecentTransfer/recentTransfer';

import './userDashboard.scss';

class UserDashbord extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // providers: defaultProviders,
        }
    }

    componentDidMount() {
        const { match } = this.props
        let user = JSON.parse(localStorage.getItem('user')) || {
            bypass_onboard: true,
        }
    }

    on_show_compare = () => {
        // const { history } = this.props
        // history.push('/cloud-compare/0')
    }

    render() {
        const { providers } = this.state
        const { match } = this.props
        const { user, history } = this.props
        const { TabPane } = Tabs;
        // if (!user.cloud_accounts_count) {
        //     history.push('/addProvider')
        //     return <div />
        // }
        return (
            <div className="userDashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Users</h2>
                    </div>
                    {/* <div className="right-wrapper">
                        <Button 
                            className="add-user-btn"
                            type="primary" 
                            onClick={() => history.push('/addProvider')}>
                            Add New User
                        </Button>
                    </div> */}
                </div>
                <Tabs defaultActiveKey="1" centered>
                    <TabPane tab="Dashboard" key="1">
                        <div className="active-jobs-wrapper">
                            <ActiveJobsList/>
                        </div>
                    </TabPane>
                    <TabPane tab="Cloud Providers" key="2">
                        <div className="active-jobs-wrapper">
                            {/* <ActiveJobsList/> */}
                        </div>
                    </TabPane>
                    <TabPane tab="Replication" key="3">
                        <div className="scheduled-replication-wrapper">
                            <div className="syncReportHeader">
                                <h2>Scheduled Replication Jobs</h2>
                            </div>
                            <SyncList/>
                        </div>
                    </TabPane>
                    <TabPane tab="Migration/Transfer history" key="4">
                        <TransferHistory/>
                    </TabPane>
                </Tabs>
          </div>
            
        )
    }
}

export default withRouter(
    connect(
        ({ auth, cloudAccounts }, { match, history }) => {
            let user = auth.user
            return {
                ...user,
                cloudAccounts,
            }
        },
        dispatch => bindActionCreators({}, dispatch)
    )(UserDashbord)
)
